import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ResponseChoices} from '../types/chatgpt.type';
import {HttpClient} from '@angular/common/http';
import {TelegramService} from '../pages/page-telegram/telegram.service';

@Injectable({
  providedIn: 'root'
})
export class ChatGptService {
  load$: Subject<boolean> = new Subject();
  constructor(
    public telegramService: TelegramService,
    private http: HttpClient
  ) { }
  sendPrompt(prompt: string): Observable<ResponseChoices> {
    return (this.http.post(`${this.telegramService.urlApi}/api/sender/gpt`, {
      prompt
    }) as any);
  }
}

